export enum LogLevel {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}

export const LogLevelMapping: {[key in LogLevel]: number} = {
  [LogLevel.INFO]: 20,
  [LogLevel.WARNING]: 30,
  [LogLevel.ERROR]: 40,
};

export function getMaxLogLevel(levels: Array<LogLevel>): LogLevel {
  if (!levels.length) {
    return LogLevel.INFO;
  }
  const max = Math.max(...levels.map((level) => LogLevelMapping[level]));
  return levels.find((level) => LogLevelMapping[level] === max)!;
}
